import { Component, HostBinding, Input, OnDestroy, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { interval, Subscription } from 'rxjs';

@Component({
    selector: 'upsc-content-loading-progress',
    templateUrl: './content-loading-progress.component.html',
    styleUrls: ['./content-loading-progress.component.scss'],
})
export class ContentLoadingProgressComponent implements OnInit, OnDestroy {
    @Input() public loaderSize = 12;
    @Input() public messageRotationPeriod = 5000;
    @HostBinding('class') public hostClass = 'content-loading-progress';
    public loadingMessage: string;
    private subscription = new Subscription();
    private loadingMessagesSubscription: Subscription;
    private readonly messages: string[];

    public constructor(private readonly translateService: TranslateService) {
        this.messages = this.translateService.instant('loadingMessages');
    }

    public ngOnInit(): void {
        this.updateLoadingMessages();
    }

    public ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }

    private updateLoadingMessages(): void {
        if (!this.messages?.length) {
            return;
        }

        let messageIndex = 0;
        this.loadingMessage = this.messages[messageIndex];

        this.loadingMessagesSubscription = interval(this.messageRotationPeriod).subscribe(() => {
            messageIndex = (messageIndex + 1) % this.messages.length;
            this.loadingMessage = this.messages[messageIndex];
        });

        this.subscription.add(this.loadingMessagesSubscription);
    }
}
